module.exports = __webpack_public_path__ + "img/jiaotong.db98533d.jpg";